import React, { useEffect, useState } from "react";

const IntroVideo = ({
  videoId = "X6n4kFvpwcc",
  title = "Alysei Intro",
  popup = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen]);

  return (
    <section
      className="relative w-full py-16  px-5 md:px-16 overflow-hidden"
      style={{ backgroundColor: "#e8f4fb" }}
    >
      <div className="relative z-10 w-full max-w-2xl mx-auto">
        <div
          className="relative w-full overflow-hidden rounded-2xl shadow-2xl"
          style={{
            paddingTop: "56.25%",
            boxShadow: "0 18px 36px rgba(0, 69, 119, 0.24)",
          }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
          {popup && (
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              aria-label={`Play ${title} in fullscreen`}
              className="group absolute inset-0 w-full h-full flex items-center justify-center transition-colors focus:outline-none"
              style={{ backgroundColor: "transparent" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.25)")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              <span
                className="flex items-center justify-center shadow-lg transition-transform duration-200 group-hover:scale-110"
                style={{
                  width: "68px",
                  height: "48px",
                  borderRadius: "14px",
                  backgroundColor: "#ff0000",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="white"
                  aria-hidden="true"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
            </button>
          )}
        </div>
      </div>

      {popup && isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label={title}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            padding: "16px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "min(90vw, calc((100vh - 6rem) * 16 / 9))",
            }}
          >
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              aria-label="Close video"
              style={{
                position: "absolute",
                top: "-32px",
                right: 0,
                color: "#ffffff",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: 300,
                lineHeight: 1,
                cursor: "pointer",
                padding: 0,
              }}
            >
              ×
            </button>

            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%",
                overflow: "hidden",
                backgroundColor: "#000",
                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              }}
            >
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1&playsinline=1&iv_load_policy=3&loop=1&playlist=${videoId}`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default IntroVideo;
